import { Navigate, Outlet, useLocation } from "react-router-dom";

import { ScreenLoader } from "@/components/loaders";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";

const AuthRoutes = () => {
  const isLoading = false;
  const location = useLocation();

  const token = useSelector((state: RootState) => state?.auth?.token);

  if (isLoading) {
    return <ScreenLoader />;
  }

  return !token ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export { AuthRoutes };
